import { format as formatFunction, isSameYear } from 'date-fns/esm'
import locale from 'date-fns/locale/nl-BE'
import { formatToTimeZone } from 'date-fns-timezone'

function formatLocale(date: Date | number | string, format: string) {
  return formatFunction(new Date(date), format, { locale })
}

/**
 * A short date for a list row, such as "3 okt.". A date from another year keeps its year, so an
 * old item does not read as recent: "3 okt. 2025".
 */
function formatListDate(date: Date | number | string, now: Date = new Date()) {
  const format = isSameYear(new Date(date), now) ? 'd MMM' : 'd MMM yyyy'

  return formatLocale(date, format)
}

function formatInTZ(date: Date | number | string, format: string) {
  return formatToTimeZone(new Date(date), format, {
    timeZone: 'Europe/Brussels',
  })
}

function capitalize(string: string) {
  return string.charAt(0).toUpperCase() + string.slice(1)
}

export { capitalize, formatInTZ, formatListDate, formatLocale }
